const VIDEO_RE = /\.(mp4|webm|mov|m4v)(\?|$)/i;

export default function HeroMedia({ url }) {
    if (!url) return null;
    const cls = "w-full h-full object-cover";
    return (
        <div className="absolute inset-0 z-0 overflow-hidden" data-testid="hero-side-media">
            {VIDEO_RE.test(url) ? (
                <video src={url} autoPlay muted loop playsInline preload="metadata" className={cls} data-testid="hero-side-video" />
            ) : (
                <img src={url} alt="" className={cls} data-testid="hero-side-image" />
            )}
        </div>
    );
}
